import React, { useState } from 'react';

interface PropTypes {
  onClick?: () => void;
  percentage?: number;
  backgroundColor: string;
  width: number;
  height: number;
}

const ColumnChart: React.FC<PropTypes> = ({
  percentage = 0,
  onClick,
  backgroundColor,
  width,
  height,
}) => {
  const [isHovering, setIsHovering] = useState<boolean>();

  const colWidth =
    width === 3 && height === 2 ? 64 : width === 3 ? 32 : width === 2 ? 24 : 18;

  return (
    <div
      className={`relative w-${colWidth} flex flex-col items-center pb-2 z-10 cursor-pointer`}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onClick={onClick}
    >
      <div className="font-semibold">{percentage}%</div>
      {Array(10)
        .fill(undefined)
        .map((_, index) => {
          return (
            <div
              key={index}
              className={`relative w-9/12  bg-gradient-to-t from-grey-30 via-grey-10 to-transparent mix-blend-overlay bg-grey-10
            ${
              (10 - index) * 10 <= Math.round(percentage / 10) * 10
                ? ` bg-${backgroundColor}`
                : ''
            }
            ${
              isHovering &&
              (10 - index) * 10 <= Math.round(percentage / 10) * 10
                ? 'w-10/12'
                : ''
            }
            ${
              width > 1 && height === 2
                ? 'h-9 my-2 rounded-xl'
                : 'h-3 my-0.5 rounded-lg'
            }
            `}
            >
              <div
                className={`absolute w-full opacity-70 h-full bg-grey-10
              ${
                (10 - index) * 10 <= Math.round(percentage / 10) * 10
                  ? ` bg-${backgroundColor}`
                  : ''
              }
              ${
                isHovering &&
                (10 - index) * 10 <= Math.round(percentage / 10) * 10
                  ? 'w-10/12'
                  : ''
              }
              ${width > 1 && height === 2 ? 'rounded-xl' : 'rounded-lg'}
            `}
              />
            </div>
          );
        })}
    </div>
  );
};

export default ColumnChart;
